import dayjs from "dayjs";
import dayjsBusinessDays from "dayjs-business-days";

dayjs.extend(dayjsBusinessDays);

/**
 * Find the next Friday from a given date
 * @param {dayjs.Dayjs} date - Starting date
 * @returns {dayjs.Dayjs} - Next Friday
 */
function getNextFriday(date) {
  const dayOfWeek = date.day(); // 0 = Sunday, 5 = Friday
  const daysUntilFriday = dayOfWeek <= 5 ? 5 - dayOfWeek : 7 - dayOfWeek + 5;

  if (daysUntilFriday === 0) {
    // Today is Friday, return next Friday
    return date.add(7, "day");
  }

  return date.add(daysUntilFriday, "day");
}

/**
 * Generate next N Friday expiration dates
 * @param {number} count - Number of expirations (default 3)
 * @param {dayjs.Dayjs} customDate - Custom "today" date (optional)
 * @returns {dayjs.Dayjs[]} - Array of Friday dates
 */
export function getNextExpirationDates(count = 3, customDate = null) {
  const today = customDate || dayjs();
  const expirations = [];

  let nextFriday = getNextFriday(today);

  for (let i = 0; i < count; i++) {
    expirations.push(nextFriday);
    nextFriday = nextFriday.add(7, "day"); // Next week's Friday
  }

  return expirations;
}

/**
 * Format expiration date to YYYYMMDD string
 * @param {dayjs.Dayjs} date - Date to format
 * @returns {string} - Formatted date string
 */
export function formatExpirationDate(date) {
  return date.format("YYYYMMDD");
}
